export default __webpack_public_path__ + "static/media/smartphone.ba89d8a5.png";